<template>
  <div class="boilerplate-selection">
    <!-- <h2>Select a Boilerplate</h2>
    <div v-for="boilerplate in boilerplates" :key="boilerplate.name" class="boilerplate-item" @click="selectBoilerplate(boilerplate)">
      <img :src="boilerplate.img" :alt="boilerplate.name" class="boilerplate-img" />
      <p>{{boilerplate.alt}}</p>
    </div> -->
    <h4> Cartago®Live Designer Templates</h4>
    <div class="designer-section">
      <p><span class="material-symbols-outlined">database</span><span>root</span>
        <span class="material-symbols-outlined">chevron_right</span> 
        <span class="material-symbols-outlined">folder</span>
         DemoTemplates</p>
      <ul class="designerTree" v-for="template in templates" :key="template.key">
        <li @click="selectBoilerplate(template)"><span class="material-symbols-outlined">draft</span> {{ template.label }}</li>
      </ul>
    </div>
    <div class="upload-section">
      <div class="divider">
      <h4>{{ $t('Add.Boilerplate.UploadSection') }}</h4>
      <label class="upload-label">
        <span class="material-symbols-outlined">upload</span>
        {{ $t('Add.Boilerplate.UploaddInfo1') }}
        <input type="file" @change="uploadBoilerplate" />
      </label>
    </div>
    <div class="divider">
      <label class="upload-label">
        <span class="material-symbols-outlined">upload</span>
        {{ $t('Add.Boilerplate.UploadInfo2') }}
        <input type="file" @change="uploadDesigner" />
      </label>
    </div>
  </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AddBoilerplate',
  data() {
    return {
      templates: [
        { 
          label: 'Mahnungs_table', 
          file: 'boiler1.json', 
        },
        { 
          label: 'Bestellliste_table', 
          file: 'boiler4.json', 
        },
        { 
          label: 'LidlFooter', 
          file: 'boiler2.json', 
        },
        { 
          label: 'LidlHeader', 
          file: 'boiler3.json', 
         }
      ],
    };
  },
  methods: {
    async selectBoilerplate(boilerplate) {
      try {
        const response = await axios.get(`/boilerplates/${boilerplate.file}`);
       /*  const response = await axios.get(`/designerHtml/${boilerplate.file}`); */
        this.$store.dispatch('addBoilerplate', response.data);
      } catch (error) {
        console.error('Failed to load boilerplate:', error);
      }
    },
    uploadBoilerplate(event) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const boilerplate = JSON.parse(e.target.result);
          this.$store.dispatch('addBoilerplate', boilerplate);
        } catch (error) {
          console.error('Invalid JSON file:', error);
        }
      };
      reader.readAsText(file);
    },
    /* uploadDesigner(event) {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(e.target.result, 'text/html');
        const bodyElement = doc.body;

        if (!bodyElement || !bodyElement.innerHTML) {
          console.error('No body content found in the HTML file');
          return;
        }

        // Extrahiere den Inhalt und die Attribute des <body>-Tags
        const bodyContent = bodyElement.innerHTML;
        const bodyAttributes = Array.from(bodyElement.attributes)
          .map(attr => `${attr.name}="${attr.value}"`)
          .join(' ');

        // Erzeuge das <div> mit denselben Attributen wie <body>
        const divContent = `<div ${bodyAttributes}>${bodyContent}</div>`;
        const id = `block-${Math.floor(Math.random() * 900000000000) + 1000000000000}`;
        const htmlBlock = {
          [id]: {
            type: "Html",
            data: {
              props: {
              contents: divContent
            },
              style: {
                padding: {
                  top: 0,
                  bottom: 0,
                  right: 0,
                  left: 0
              }
            }
          }
        }
        };

        this.$store.dispatch('addBoilerplate', htmlBlock);

      } catch (error) {
        console.error('Failed to process the HTML file:', error);
      }
    };
    reader.readAsText(file); 
  } */
  uploadDesigner(event) {
    
  const file = event.target.files[0];
  const reader = new FileReader();
  reader.onload = (e) => {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(e.target.result, 'text/html');
      const bodyElement = doc.body;

      if (!bodyElement || !bodyElement.innerHTML) {
        console.error('No body content found in the HTML file');
        return;
      }

      // Extrahiere den Inhalt und die Attribute des <body>-Tags
      const bodyContent = bodyElement.innerHTML;
      const bodyAttributes = Array.from(bodyElement.attributes)
        .map(attr => `${attr.name}="${attr.value}"`)
        .join(' ');

      // Erzeuge das <div> mit denselben Attributen wie <body>
      const divContent = `<div ${bodyAttributes}>${bodyContent}</div>`;
      const id = `block-${Math.floor(Math.random() * 900000000000) + 1000000000000}`;
       // Extrahiere Media Queries aus <style>-Tags
      const styleTags = doc.querySelectorAll('style');
      let mediaQueries = '';

      styleTags.forEach((styleTag) => {
        const cssRules = styleTag.sheet?.cssRules;
        if (cssRules) {
          for (let i = 0; i < cssRules.length; i++) {
            if (cssRules[i] instanceof CSSMediaRule) {
              mediaQueries += cssRules[i].cssText;
            }
          }
        }
      })
      const htmlBlock = {
        [id]: {
          type: "Html",
          data: {
            props: {
              contents: divContent
            },
            style: {
              padding: {
                top: 0,
                bottom: 0,
                right: 0,
                left: 0
              }
            }
          },
          mediaQueries: mediaQueries
        }
      };


      this.$store.dispatch('addBoilerplate', htmlBlock);

    } catch (error) {
      console.error('Failed to process the HTML file:', error);
    }
  };
  reader.readAsText(file);
}

}
};
</script>

<style scoped>
.boilerplate-selection {
  padding: 20px;
}

.boilerplate-item {
  margin: 10px 0;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
  transition: transform 0.3s, box-shadow 0.3s;
}

.boilerplate-item:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.boilerplate-img {
  width: 100%;
  height: auto;
  display: block;
}

.upload-section {
  margin-top: 20px;
  text-align: center;
}

.upload-label {
  display: inline-block;
  padding: 10px 20px;
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 4px;
  transition: background-color 0.3s, box-shadow 0.3s;
}

.upload-label:hover {
  background-color: #e0e0e0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.upload-label .material-symbols-outlined {
  vertical-align: middle;
  margin-right: 8px;
}

.upload-label input[type="file"] {
  display: none;
}

.divider{
  margin-bottom: 10px;
}

p{
  display: flex;
  justify-content:center;
  align-items: center;
  background: white;
  font-size: 13px;
}


ul {
list-style-type: none;
padding-left: 20px;
}

li {
cursor: pointer;
display: flex;
align-items: center;
font-size: 13px;
}

li:hover{
  background: #cccc;
}

.material-symbols-outlined{
  margin-right: 5px;
  font-size: 20px;
}

h4{
  text-align:left;
}

.designer-section{
  border: 1px solid black;
  background: #f7f7f7cc;
  overflow-y: scroll;
  overflow-x: hidden;
  margin-bottom: 60px;
}
</style>
 